export const OrderRouting = [
  {
    path: "/expense/order/list",
    name: "expense-order-list",
    meta: { title: "订单管理" },
    component: () =>
      import(/* webpackChunkName: "expense-order" */ "@/views/expense/order/list/index.vue"),
  },
  {
    path: "/expense/order/info",
    name: "expense-order-info",
    meta: { title: "订单详情" },
    component: () =>
      import(
        /* webpackChunkName: "expense-order-info" */ "@/views/expense/order/order-info/index.vue"
      ),
  },
];
